<template>
  <div class="request-subjects__user text-dark">
    <div class="request-subjects__user__header">
      <h2 class="pad-1">Dine ønsker</h2>
    </div>
    <table class="d-table">
      <thead>
      <th></th>
      <th></th>
      <th></th>
      <th class="number">
        {{ sumOfHours }}
      </th>
      </thead>
      <tbody>
      <tr v-if="userSubjects.length === 0">
        <td colspan="3" class="italic">Ingen fag ønsket</td>
      </tr>
      <tr v-for="subject in userSubjects" :key="subject.id">
        <td class="td-delete">
          <div class="icon__bg-circle icon-bin"
               @click="$emit('removeSubject', subject.id)"
               v-if="!loadingSubjects[subject.id]"></div>
          <div class="do-spinner do-spinner-small" v-else></div>
        </td>
        <td class="td-subjects">
          <div class="subjects_subject subjects_subject__simple"
               :class="{'subjects_subject--has-user': subject.vRequestedBy.length > 0}"
               :style="[{'border-left-color': subject.color}, {'background-color': subject.color}]"
               :content="!subject.vHasTeachers ? 'Ønsket af ' + subject.vRequestedBy : subject.vUserNames + ' er valgt'"
               v-tippy="{
            arrow: true,
            onShow: () => subject.vRequestedBy.length > 0
          }">
            {{ subject.name }}
          </div>
        </td>
        <td class="td-calendars">{{ subject.vKlass }}</td>
        <td class="number">
          {{ subject.hours }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    user: {
      type: Object,
      default: {
        name: ''
      }
    },
    userSubjects: {
      type: Array,
      default: () => []
    },
    allCalendarsInHash: {
      type: Object,
      default: () => {
      }
    },
    loadingSubjects: {
      default: {}
    }
  },
  computed: {
    sumOfHours () {
      return this.userSubjects
        .reduce((sum, subject) => sum + parseFloat(subject.hours), 0)
        .toFixed(1)
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.request-subjects__user {
  max-width: 300px;
  min-width: 300px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.number {
  text-align: right;
}


.subjects_subject {
  position: relative;
  padding: 4px 6px;
  height: 30px;
  color: #ffffff;
  border-radius: 4px;
  word-break: break-all;
  background: transparent;
  overflow: hidden;
  text-align: left;
  margin: 2.5px 5px 2.5px 0px;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  border-left: 2px solid transparent;
  animation: fadeIn;
  cursor: pointer;
  width: 135px;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
}

.subjects_subject.subjects_subject--has-user {
  padding-right: 20px;
}

.subjects_subject.subjects_subject--has-user:after {
  content: "\eaf7";
  position: absolute;
  top: 9px;
  right: 3px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #b7b7b7;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.subjects_subject.subjects_subject__simple {
  border: 1px solid var(--border-color);
  border-left: 2px solid transparent;
  background: #ffffff !important;
  color: var(--dark-blue);
  box-shadow: none;
}

.d-table, .subjects-and-tasks {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
  border-width: 1px 0;
}

.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  border-width: 1px 0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th, .d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child, .d-table > tfoot > tr:first-child {
  color: #8898aa;
}

.d-table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 2px 4px;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table td,
.d-table th {
  padding: 0 4px;
}

.td-subjects {
  width: 135px;
}

.td-calendars {
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 65px;
  overflow: hidden;
  font-size: 11px;
}

.d-table td.td-subjects {
  position: relative;
  padding: 0 4px 0 0;
}

.number-and-delete .do-bttn {
  display: none;
}

tr:hover > .number-and-delete > span {
  display: none;
}
tr:hover > .number-and-delete > .do-bttn {
  display: inline-block;
}

.td-delete {
  width: 20px;
  padding: 0 !important;
}

.td-delete .do-spinner {
  margin: 0 6px;
}

</style>



// WEBPACK FOOTER //
// RequestSubjectsUser.vue?c7fe19f6